import {
    Button,
    Modal,
    Option,
    Select,
    selectClasses,
    Switch,
  } from "@mui/joy";
  import { BLACK, WHITE } from "../../../../../appConstants";
  import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
  } from "react";
  import CalenderIcon from "../../../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import CompareTwoDateRangeComponent from "../../../ComparisonDateRangeComponent/CompareTwoDateRangeComponent 1";
import DragAndDropIcon from "../../../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import toast from "react-hot-toast";
import MultiSelect from "../../../MultiSelect";
import DateRangeComponent from "../../../SummaryDateRangeComponent/DateRangeComponent 1";

  type Matrice = {
    id: number;
    matrice_name: string;
    backend_matrice_name: string;
    toggle: boolean;
    position: number;
  };
  type RangeProps = {
    min_date: Date;
    max_date: Date;
  };
  type WeekProps = [number, number];

type FilterProps = {
  filter_type: string;
  type: string;
  month: number[];
  year: number[];
  week: WeekProps[];
  start_date: Date;
  end_date: Date;
};
type DateProps = {
  startDate: Date;
  endDate: Date;
};
type MonthProps = {
  id: string;
  label: string;
};
type YearProps = {
  id: string;
  label: string;
};
  type SummaryCustomExportModalProps = {
    setToggle: Dispatch<SetStateAction<boolean>>;
    ip_maxminRange: RangeProps;
    ip_filter: FilterProps;
    ip_years: YearProps[],
    ip_months: MonthProps[],
    ip_weeks: MonthProps[],
    matricesData: Matrice[];
    ip_transposeFormat: string;
    exportfunc : (filter: FilterProps, ip_matrices: Matrice[], transposeFormat: string, startDate: string, endDate: string, selweeks: WeekProps[]) => void;
    loading: boolean;
  };
  
  const OverviewSummaryCustomExportModal: React.FC<SummaryCustomExportModalProps> = ({
    setToggle,
    ip_maxminRange,
    ip_filter,
    ip_years,
    ip_months,
    ip_weeks,
    ip_transposeFormat,
    matricesData,
    exportfunc,
    loading
  }) => {
    const [filter, setFilter] = useState<FilterProps>({} as FilterProps);    
    const [range, setRange] = useState<RangeProps>({} as RangeProps);
    const [initial_matrices, setInitial_matrices] = useState<Matrice[]>([]);
    const [dateToggle, setDateToggle] = useState<boolean>(false);
    const [transposeFormat, setTransposeFormat] = useState<string>("");

  const [selectedYears, setSelectedYears] = useState<Set<string>>(new Set([]));

  const onYearChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedYears);

    if (e.target.checked) {
      if (id === "Select All") {
        ip_years.forEach((m) => set.add(m.id));
        setFilter((prev) => {
          return {
          ...prev,
          filter_type: "SEGMENT",
          year: ip_years
            .filter((m) => m?.id !== "Select All") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
          }
        });

      } else if (id !== "Select All") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          year: [...prev.year, Number(id)],
          filter_type: "SEGMENT",
        }));
        if (set.size === ip_years?.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === ip_years?.length) {
        set.clear();

        if(filter?.week?.length === 0 && filter?.month?.length === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "SEGMENT",
          }));
        }

      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);

        if(filter?.week?.length === 0 && filter?.month?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else{
          setFilter((prev) => ({
            ...prev,
            year: prev.year.filter((yearId) => yearId !== Number(id)),
            filter_type: "SEGMENT",
          }));
        }

      }
    }
    setSelectedYears(set);
  };

  // ---- Months
  const [selectedMonths, setSelectedMonths] = useState<Set<string>>(
    new Set([])
  );

  const onMonthChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedMonths);
    if (e.target.checked) {
      if (id === "13") {
        ip_months.forEach((m) => set.add(m.id));
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: ip_months
            .filter((m) => m?.id !== "13") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
        }));
      } else if (id !== "13") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: [...prev.month, Number(id)],
        }));
        if (set.size === ip_months.length - 1) {
          set.add("13");
        }
      }
    } else {
      if (id === "13" && set.size === ip_months.length) {
        set.clear();

        if(filter?.year?.length === 0 && filter?.week?.length === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: [],
          }));
        }

      } else if (id !== "13") {
        if (set.has("13")) {
          set.delete("13");
        }
        set.delete(id);

        if(filter?.year?.length === 0 && filter?.week?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: prev.month.filter((monthId) => monthId !== Number(id)),
          }));
        }

      }
    }
    setSelectedMonths(set);
  };

  const [selectedWeeks, setSelectedWeeks] = useState<Set<string>>(new Set([]));
  const [selweeks, setSelweeks] = useState<WeekProps[]>([]);

  const onWeekChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedWeeks);
    if (e.target.checked) {
      if (id === "6") {
        ip_weeks.forEach((m) => set.add(m?.id));
        setSelweeks(() => [
          [1, 7],
          [8, 14],
          [15, 21],
          [22, 28],
          [29, 31],
        ]);
      } else if (id !== "6") {
        set.add(id);
        if (set.size === ip_weeks.length - 1) {
          set.add("6");
        }
        if (id === "1") {
          setSelweeks((prev) => [...prev, [1, 7]]);
        } else if (id === "2") {
          setSelweeks((prev) => [...prev, [8, 14]]);
        } else if (id === "3") {
          setSelweeks((prev) => [...prev, [15, 21]]);
        } else if (id === "4") {
          setSelweeks((prev) => [...prev, [22, 28]]);
        } else if (id === "5") {
          setSelweeks((prev) => [...prev, [29, 31]]);
        }
      }
    } else {
      if (id === "6" && set.size === ip_weeks.length) {
        set.clear();
        setSelweeks([]);
      } else if (id !== "6") {
        if (set.has("6")) {
          set.delete("6");
        }
        if (set.has(id)) {
          set.delete(id);
          if (id === "1") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 1 && range[1] === 7))
            );
          } else if (id === "2") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 8 && range[1] === 14))
            );
          } else if (id === "3") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 15 && range[1] === 21))
            );
          } else if (id === "4") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 22 && range[1] === 28))
            );
          } else if (id === "5") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 29 && range[1] === 31))
            );
          }
        }
      }
    }
    let dummyset = [...set];
    dummyset = dummyset.filter((item) => item !== "6");
    const datesarr: WeekProps[] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];
    const weeksarr: WeekProps[] = dummyset.map((i) => datesarr[Number(i) - 1]);
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && weeksarr?.length === 0){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }
    else {
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeksarr,
      }));
    }
    setSelectedWeeks(set);
  };

  // OR Date
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let start, end;
    if (e.target.name === "startDate") {
      start = e.target.value;
      setStartDate(e.target.value);
    } else {
      end = e.target.value;
      setEndDate(e.target.value);
    }
    let weeklist: WeekProps[] = [];
    if (startDate && end) {
      weeklist = [[Number(startDate), Number(end)]];
    } else if (start && endDate) {
      weeklist = [[Number(start), Number(endDate)]];
    }
    // else if(startDate !== "" && end === "" || start === "" && endDate !== "" || startDate === "" && endDate === ""){
    //   weeklist = [];
    // }
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && filter?.week?.length > 0 && filter?.filter_type === "SEGMENT"){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }

    if((startDate && end) || (start && endDate)){
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeklist,
      }));
    } 

  };

  const apply = (date: DateProps) => {
    setFilter((prev) => ({
      ...prev,
      filter_type: "TIMELINE",
      start_date: date?.startDate,
      end_date: date?.endDate,
    }));
  };

    // For Metricess
    const MatriceSwitchChangeHandler = (matrice_id: Number) => {
        const Exist = initial_matrices.find(
            (d: Matrice) => d?.id === matrice_id
        )?.toggle;
        let newMatricesArr = [] as Matrice[];
        if (Exist) {
            if (initial_matrices.filter((item) => item.toggle).length === 1) {
                toast.error("Minimum 1 Matrice to be present");
                return;
            } else if (initial_matrices.filter((item) => item.toggle).length > 1) {
                newMatricesArr = initial_matrices.map((d) =>
                    d.id === matrice_id ? { ...d, toggle: false } : d
                );
            }
        } else {
            newMatricesArr = initial_matrices.map((d) =>
            d.id === matrice_id ? { ...d, toggle: true } : d
            );
        }
        setInitial_matrices(newMatricesArr);
        // updateColumns([], "METRICE", [], newMatricesArr, true);
    };

    // For Metrice
    const [draggedMetrice, setDraggedMetrice] = useState<Matrice | null>(null);

    const metriceDragStarthandle = (item: Matrice) => {
        setDraggedMetrice(item);
    };

    const metriceDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const metricehandleDrop = (targetItem: Matrice) => {
        if (!draggedMetrice || draggedMetrice.id === targetItem.id) return;
    
        const draggedIndex = initial_matrices.findIndex(
        (item) => item?.id === draggedMetrice.id
        );
        const targetIndex = initial_matrices.findIndex(
        (item) => item?.id === targetItem.id
        );
    
        if (draggedIndex === -1 || targetIndex === -1) return;
    
        // Clone the array to avoid mutating state directly
        const updatedMatricesData = [...initial_matrices];
    
        // Remove the dragged item
        const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
    
        // Insert it at the target index
        updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
    
        // Reassign position field based on new order
        const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
        ...item,
        position: index,
        }));
        setInitial_matrices(reorderedMatricesData);
        // }
    };
    
    const exportHandler = () => {

        let selected_matrics = initial_matrices?.filter((d) => d?.toggle === true);

        exportfunc(filter, selected_matrics, transposeFormat, startDate, endDate, selweeks);
    }

    useEffect(() => {
        setInitial_matrices(matricesData);
        setFilter(ip_filter);
        setRange(ip_maxminRange);
        setTransposeFormat(ip_transposeFormat);
    }, []);

    const periodArr = [
        {frontend_name: "DAILY", backend_name: "day"},
        {frontend_name: "WEEKLY", backend_name: "week"},
        {frontend_name: "MONTHLY", backend_name: "month"},
        {frontend_name: "ALL", backend_name: "all"},
    ];

    return (
      <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className="h-full"
      >
        <div className="relative">
          <div
            style={{
              width: 1200,
              height: 700,
              paddingLeft: 40,
              paddingRight: 40,
              paddingBottom: 40,
              paddingTop: 40,
              backgroundColor: `${WHITE.W_100}`,
            }}
            className="flex flex-col items-center justify-between rounded-[16px] gap-10"
          >
            <div className="h-[84px] flex justify-between items-start gap-1 w-full">
                <div className="flex flex-col w-[30%]">
                    <div
                        className="self-stretch"
                        style={{
                        color: `#1C1C1E`,
                        fontSize: 20,
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "26px",
                        }}
                    >
                        Select Export Preferences
                    </div>
                    <div
                        className="self-stetch"
                        style={{
                        color: `#97979A`,
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "22px",
                        }}
                    >
                        Export the table or customise with specific Product Details, Metrics 
                    </div>
                </div>

                <div className="h-[84px] flex flex-col gap-2 justify-between items-end">
                  <div
                    className="flex w-fit items-center justify-start gap-[10px] "
                  >
                    <div
                      className="flex px-[6px] py-[4px] items-center gap-2 rounded-[4px] h-[40px]"
                      style={{
                        border: "1px solid #EAEAED",
                      }}
                    >
                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_years}
                          selected={selectedYears}
                          onChange={onYearChange}
                          placeholder="Select Years"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                        />
                      </div>

                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_months}
                          selected={selectedMonths}
                          onChange={onMonthChange}
                          placeholder="Select Months"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                        />
                      </div>

                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_weeks}
                          selected={selectedWeeks}
                          onChange={onWeekChange}
                          placeholder="Select Weeks"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                          disabled={startDate && endDate ? true : false}
                        />
                      </div>

                      <div className="flex flex-col items-center gap-[2px]">
                        <div
                          style={{
                            border: "1px solid #EAEAED",
                            height: "9px",
                            width: "0px",
                          }}
                        ></div>
                        <div
                          style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            textAlign: "center",
                            fontFamily: "Inter",
                            fontSize: "8px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "10px", // 125%
                            letterSpacing: "1.6px",
                            textTransform: "uppercase",
                          }}
                        >
                          OR
                        </div>
                        <div
                          style={{
                            border: "1px solid #EAEAED",
                            height: "9px",
                            width: "0px",
                          }}
                        ></div>
                      </div>

                      <input
                        type="text"
                        placeholder="From"
                        name="startDate"
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          lineHeight: "14px",
                          color: "#97979A",
                          border: "1px solid #F2F2F5",
                          borderRadius: "4px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          width: "60px",
                          backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                        }}
                        value={startDate}
                        onChange={handleChange}
                        disabled={selweeks.length > 0 && true}
                      />
                      <input
                        type="text"
                        placeholder="Till"
                        name="endDate"
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          lineHeight: "14px",
                          color: "#97979A",
                          border: "1px solid #F2F2F5",
                          borderRadius: "4px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          width: "60px",
                          backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                        }}
                        value={endDate}
                        onChange={handleChange}
                        disabled={selweeks.length > 0 && true}
                      />
                    </div>

                    <div className="flex flex-col items-center gap-[2px]">
                      <div
                        style={{
                          border: "1px solid #EAEAED",
                          height: "10px",
                          width: "0px",
                        }}
                      ></div>
                      <div
                        style={{
                          color: "var(--Text-Primary-Grey, #97979A)",
                          textAlign: "center",
                          fontFamily: "Inter",
                          fontSize: "8px",
                          fontStyle: "normal",
                          fontWeight: 500,
                          lineHeight: "10px", // 125%
                          letterSpacing: "1.6px",
                          textTransform: "uppercase",
                        }}
                      >
                        OR
                      </div>
                      <div
                        style={{
                          border: "1px solid #EAEAED",
                          height: "10px",
                          width: "0px",
                        }}
                      ></div>
                    </div>

                    <div
                      className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
                      style={{
                        border: "1px solid #EAEAED",
                        position: "relative",
                        backgroundColor:
                          filter?.year?.length !== 0 ||
                          filter?.month?.length !== 0 ||
                          filter?.week?.length !== 0
                            ? "#F3F3F7"
                            : "#FFF",
                        pointerEvents:
                          filter?.year?.length !== 0 ||
                          filter?.month?.length !== 0 ||
                          filter?.week?.length !== 0
                            ? "none"
                            : "auto",
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <div
                          style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "14px",
                          }}
                        >
                          {`${String(filter?.start_date?.getDate()).padStart(
                            2,
                            "0"
                          )}/${String(filter?.start_date?.getMonth() + 1).padStart(
                            2,
                            "0"
                          )}/${filter?.start_date?.getFullYear()} - ${String(
                            filter?.end_date?.getDate()
                          ).padStart(2, "0")}/${String(
                            filter?.end_date?.getMonth() + 1
                          ).padStart(2, "0")}/${filter?.end_date?.getFullYear()} `}
                        </div>
                      </div>
                      <img
                        src={CalenderIcon}
                        alt="OverView Icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setDateToggle(true)}
                      />
                      {dateToggle && (
                        <div
                          className="absolute "
                          style={{ top: "37px", right: "0px", zIndex: 100 }}
                        >
                          <DateRangeComponent
                            range={{
                              startDate: filter?.start_date,
                              endDate: filter?.end_date,
                            }}
                            apply={apply}
                            minDate={range?.min_date}
                            maxDate={range?.max_date}
                            setDateToggle={setDateToggle}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="w-full h-[36px] flex justify-between">
                    <div className="h-[36px] w-[130px]">
                        <Select
                        className="w-full"
                        onChange={(e: any, value: any) => setTransposeFormat(value)}
                        name="transpose"
                        value={transposeFormat}
                        indicator={
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            >
                            <path
                                d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                                fill="#1C1C1C"
                                fill-opacity="0.4"
                            />
                            </svg>
                        }
                        slotProps={{
                            listbox: {},
                        }}
                        sx={{
                            "--Input-focusedThickness": "0px",
                            height: "32px",
                            color: "#1C1C1E",
                            fontSize: 14,
                            fontWeight: 400,
                            lineHeight: "20px",
                            backgroundColor: WHITE.W_100,
                            boxShadow: "none",
                            border: `1px solid #EAEAED`,
                            [`& .${selectClasses.indicator}`]: {
                            transition: "0.2s",
                            [`&.${selectClasses.expanded}`]: {
                                transform: "rotate(-180deg)",
                            },
                            },
                            ":hover": {
                            backgroundColor: WHITE.W_100,
                            },
                        }}
                        >
                            <Option value={"VERTICAL"}>V-Summary</Option>
                            <Option value={"HORIZONTAL"}>H-Summary</Option>
                        </Select>
                    </div>
                    <div
                        className="flex h-[31px]  items-center justify-end self-stretch"
                        style={{
                        borderBottom: "1px solid #EAEAED",
                        }}
                    >
                        {periodArr?.map((p) => (
                            <div
                            style={{
                                display: "flex",
                                padding: "0px 16px",
                                justifyContent: "center",
                                alignItems: "center",
                                alignSelf: "stretch",
                                cursor: "pointer",
                                borderBottom:
                                filter?.type === p?.backend_name
                                    ? "1px solid #1565C0"
                                    : "0px",
                            }}
                            key={p?.backend_name}
                            onClick={() => {
                                setFilter((prev) => ({
                                ...prev,
                                type: p?.backend_name,
                                }));
                            }}
                            >
                            <div
                                style={{
                                color:
                                    filter?.type === p?.backend_name
                                    ? "#1565C0"
                                    : "var(--Text-Primary-Grey, #97979A)",
                                textAlign: "center",
                                fontFamily: "Inter",
                                fontSize: "12px",
                                fontStyle: "normal",
                                fontWeight: filter?.type === p?.backend_name ? 600 : 500,
                                lineHeight: "10px",
                                letterSpacing: "1.6px",
                                textTransform: "uppercase",
                                }}
                            >
                                {`${p?.frontend_name} DATA`}
                            </div>
                            </div>
                        ))}
                    </div>
                  </div>

                </div>
            </div>

            <div className="w-full h-[416px] flex gap-10">

                {/* Metrices */}
              <div
                className="flex flex-col items-start h-fit gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                  flex: .5,
                  maxHeight: '100%',
                  height: "fit-content"
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom: "1px solid #EAEAED"
                  }}
                //   onClick={() => {
                //     if (drawerSubOption === "METRICES") {
                //       setDrawerSubOption("");
                //     } else {
                //       setDrawerSubOption("METRICES");
                //     }
                //   }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start self-stretch" style={{
                    overflowY: 'auto',
                }}>
                    {initial_matrices.length > 0 &&
                    initial_matrices?.map((m: Matrice) => (
                        <div
                            className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                            key={m?.matrice_name}
                            draggable
                            onDragStart={() => metriceDragStarthandle(m)}
                            onDragOver={metriceDragOverhandle}
                            onDrop={() => metricehandleDrop(m)}
                        >
                            <div className="flex items-center gap-1">
                            <img
                                src={DragAndDropIcon}
                                alt="Drag And Drop Icon"
                                style={{ cursor: "pointer" }}
                            />
                            <div
                                className=""
                                style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                                }}
                            >
                                {m?.matrice_name}
                            </div>
                            </div>
                            <Switch
                            checked={m?.toggle}
                            onChange={(event) =>
                              MatriceSwitchChangeHandler(m?.id)
                            }
                            />
                        </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center gap-10 self-stretch">
              <Button
                color="neutral"
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#FFF",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                  color: "#1C1C1E",
                  borderRadius: "8px",
                  border: "1px solid #F2F2F5",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                onClick={() => setToggle(false)}
              >
                Cancel
              </Button>
              <Button
                onClick={exportHandler}
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#1565C0",
                  color: "#FFF",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                loading={loading}
              >
                Export
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  
  export default OverviewSummaryCustomExportModal;
  